module.exports = __webpack_public_path__ + "img/IEC13737.d679a525.png";